// All quotes from "Who Are My Clients?" by Antoine B. Carrière.
// OCR-cleaned. Quotes 29–32 have matching designed images.

export const AUTHOR_ATTRIBUTION = "Antoine B. Carrière";

export const QUOTES = [
  { id: "q-01", text: "A business solves people's problems." },
  { id: "q-02", text: "You need to know, to understand, where the buying decision originated." },
  { id: "q-03", text: "It is time to create a new movement, a new culture: a movement that focuses on a key expertise, one of experts on their clients." },
  { id: "q-04", text: "Internal factors bring us to the decision to buy, and external factors determine if we can buy." },
  { id: "q-05", text: "A business, no matter what it does or where in the world it is, is not a business if it does not have clients." },
  { id: "q-06", text: "Internal factors are the feelings and motivations that can't be put into actual data — that can't be seen, measured or quantified." },
  { id: "q-07", text: "As humans, much of what we do and think is internal to ourselves, unseen by others, so we have to move past the statistics — the data — to understand it." },
  { id: "q-08", text: "It is clear that, sometimes, logic has nothing to do with a buying decision, although we often try to rationalize it." },
  {
    id: "q-09",
    number: 9,
    featured: true,
    image: "/assets/quotes/wamc-quote-09.png",
    text: "Internal factors are why we buy — the motivation we have, the drive that pushes us to want to achieve something that has not yet been completed.",
  },
  {
    id: "q-10",
    number: 10,
    featured: true,
    image: "/assets/quotes/wamc-quote-10.png",
    text: "Although different types of people will often use the exact same product, their motivation will often be different and they need to be communicated to and served in different ways.",
  },
  {
    id: "q-11",
    number: 11,
    featured: true,
    image: "/assets/quotes/wamc-quote-11.png",
    text: "The client always intends to accomplish something with your product, and the ultimate accomplishment is the fulfillment of a core motivation.",
  },
  {
    id: "q-12",
    number: 12,
    featured: true,
    image: "/assets/quotes/wamc-quote-12.png",
    text: "Your business does not need to be the pot of gold at the end of the rainbow. It can just be one more stepping stone across a long and winding river.",
  },
  {
    id: "q-13",
    number: 13,
    featured: true,
    image: "/assets/quotes/wamc-quote-13.png",
    text: "Keep in mind that a client who is not motivated and who does not have a problem to solve, will rarely be a client.",
  },
  {
    id: "q-14",
    number: 14,
    featured: true,
    image: "/assets/quotes/wamc-quote-14.png",
    text: "Tell stories to validate all the information you have gathered on your clients, to see if they can relate to what you are sharing — be a raconteur.",
  },
  {
    id: "q-15",
    number: 15,
    featured: true,
    image: "/assets/quotes/wamc-quote-15.png",
    text: "Once your client is on-board and wants to work with you, often they become your promoter, your greatest fan.",
  },
  {
    id: "q-16",
    number: 16,
    featured: true,
    image: "/assets/quotes/wamc-quote-16.png",
    text: "There are risks to digging too deep into your client — the risk that you spend all your time analysing your client and never actually move to action.",
  },
  {
    id: "q-17",
    number: 17,
    featured: true,
    image: "/assets/quotes/wamc-quote-17.png",
    text: "External factors support the information gathered from internal factors. They refine, not define, your client.",
  },
  {
    id: "q-18",
    number: 18,
    featured: true,
    image: "/assets/quotes/wamc-quote-18.png",
    text: "Post your Client Profile on your wall as a daily reminder that the key person in your business is your client.",
  },
  {
    id: "q-19",
    number: 19,
    featured: true,
    image: "/assets/quotes/wamc-quote-19.png",
    text: "To build the business that is right for you, be honest in your self-evaluation. There is no right answer, just the right answer for you.",
  },
  {
    id: "q-20",
    number: 20,
    featured: true,
    image: "/assets/quotes/wamc-quote-20.png",
    text: "Your decision to build, improve or expand your business should be based on having found the perfect product/service and its ideal client.",
  },
  {
    id: "q-21",
    number: 21,
    featured: true,
    image: "/assets/quotes/wamc-quote-21.png",
    text: "Trying to reach everyone will inevitably allow you to connect with no one.",
  },
  {
    id: "q-22",
    number: 22,
    featured: true,
    image: "/assets/quotes/wamc-quote-22.png",
    text: "The ideal client is the one who will buy from you 90% of the time without a discount or hesitation. It's the client who will put their name on a waiting list.",
  },
  {
    id: "q-23",
    number: 23,
    featured: true,
    image: "/assets/quotes/wamc-quote-23.png",
    text: "Your time, energy, reach and funds are not endless. You therefore have to make your dollars count and the way to do this, is to focus on your ideal client.",
  },
  {
    id: "q-24",
    number: 24,
    featured: true,
    image: "/assets/quotes/wamc-quote-24.png",
    text: "Focus only on the clients whose internal factors (motivation/desire) make them most receptive to your message, even if others may align with your business.",
  },
  {
    id: "q-25",
    number: 25,
    featured: true,
    image: "/assets/quotes/wamc-quote-25.png",
    text: "It is the emotional basis, the unseen and the unquantifiable where you can best capture your client's attention and best serve their needs.",
  },
  {
    id: "q-26",
    number: 26,
    featured: true,
    image: "/assets/quotes/wamc-quote-26.png",
    text: "A key element to remember in communication is to share what is important and relevant to your client, not to you.",
  },
  {
    id: "q-27",
    number: 27,
    featured: true,
    image: "/assets/quotes/wamc-quote-27.png",
    text: "The more you know your client's core motivation, connect with it and help resolve it, the more you will connect with your ideal client.",
  },
  {
    id: "q-28",
    number: 28,
    featured: true,
    image: "/assets/quotes/wamc-quote-28.png",
    text: "Your job is to understand your customer so you can easily explain your business in a way they can understand and is relevant to them.",
  },
  {
    id: "q-29",
    number: 29,
    featured: true,
    image: "/assets/quotes/wamc-quote-29.png",
    text: "What makes human life different from all the other diverse species on this planet is that human beings desire to achieve and to actualise.",
  },
  {
    id: "q-30",
    number: 30,
    featured: true,
    image: "/assets/quotes/wamc-quote-30.png",
    text: "Penniless, I had learnt a hard lesson that although I came from the milieu, I really had not taken the time to know my client.",
  },
  {
    id: "q-31",
    number: 31,
    featured: true,
    image: "/assets/quotes/wamc-quote-31.png",
    text: "As an entrepreneur, it is your job to balance solving the problems of your clients within the realities of your own business.",
  },
  {
    id: "q-32",
    number: 32,
    featured: true,
    image: "/assets/quotes/wamc-quote-32.png",
    text: "Keep your clients first at each and every step of the sales cycle, and always remember that without clients, you will not and do not, have a business.",
  },
  { id: "q-33", text: "Over 70 percent of the buying decision is intangible and comes from the less logical part of our brain." },
  { id: "q-34", text: "You must acknowledge that as an entrepreneur, you are not just a seller of things; first, you are a problem solver." },
  { id: "q-35", text: "Just because you are delivering your service to the best of your ability doesn't mean that it is actually solving your client's problems." },
];

export const FEATURED_QUOTES = QUOTES.filter((q) => q.featured);
